module.exports = __webpack_public_path__ + "media/images/home/intro-b6c4ee27e3a9d3c8760064998225de7f.jpg";